<template>
  <div class="card">
    <div class="card-body">
      <!-- search input -->
      <div class="custom-search d-flex justify-content-end align-items-center">
        <b-form-checkbox
          v-model="onlyEntryFeeRisk"
          switch
          class="mr-2 mb-1"
          @change="reload"
        >
          Только похожие на оплату старта
        </b-form-checkbox>
        <!-- <div class="mr-auto">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            variant="primary"
            class="mr-1"
            @click="$router.push({name: 'donation', params: {id: 'new'}})"
          >
            Новый сезон
          </b-button>
        </div> -->
        <b-form-group>
          <div class="d-flex align-items-center">
            <label class="mr-1">Поиск</label>
            <b-form-input
              v-model="searchTerm"
              placeholder="Search"
              type="text"
              class="d-inline-block"
            />
          </div>
        </b-form-group>
      </div>

      <!-- table -->
      <vue-good-table
        :columns="columns"
        :rows="rows"
        :search-options="{
          enabled: true,
          externalQuery: searchTerm
        }"
        :select-options="{
          enabled: true,
          selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
          selectionInfoClass: 'custom-class',
          selectionText: 'rows selected',
          clearSelectionText: 'clear',
          disableSelectInfo: true, // disable the select info panel on top
          selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
        }"
      >
        <template
          slot="table-row"
          slot-scope="props"
        >

          <!-- Column: Status -->
          <span v-if="props.column.field === 'status'">
            <b-badge :variant="statusVariant(props.row.status)">
              {{ props.row.status }}
            </b-badge>
          </span>

          <span v-else-if="props.column.field === 'entryFee'">
            <b-badge
              v-if="hasEntryFeeRisk(props.row)"
              v-b-tooltip.hover.top="entryFeeRiskTooltip(props.row.entryFeeRisk)"
              variant="light-warning"
            >
              похоже на оплату старта
            </b-badge>
            <div
              v-if="props.row.entryFeeConfirmed"
              class="text-muted small mt-25"
            >
              подтвердил, что это не оплата участия
            </div>
          </span>

          <span v-else-if="props.column.field === 'is_primary'">
            <b-badge
              v-if="props.row.is_primary"
              variant="light-success"
            >
              Сезон по умолчанию
            </b-badge>
          </span>

          <!-- Column: Action -->
          <!-- <span v-else-if="props.column.field === 'action'">

            <span>
              <b-dropdown
                variant="link"
                toggle-class="text-decoration-none"
                no-caret
              >
                <template v-slot:button-content>
                  <feather-icon
                    icon="MoreVerticalIcon"
                    size="16"
                    class="text-body align-middle mr-25"
                  />
                </template>

                <router-link
                  :to="{name: 'donation', params:{ id: props.row.id}}"
                  class="edit-button"
                >
                  <feather-icon
                    icon="Edit2Icon"
                    class="mr-50"
                  />
                  <span>Просмотр</span>
                </router-link>

                <b-dropdown-item
                  v-b-modal.modal-primary
                  variant="outline-primary"
                  @click="seasonToDelete=props.row.id"
                >
                  <feather-icon
                    icon="TrashIcon"
                    class="mr-50"
                  />
                  <span>Удалить</span>
                </b-dropdown-item>
              </b-dropdown>
            </span>
          </span> -->

          <!-- Column: Common -->
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>
      <infinite-loading
        :identifier="infiniteId"
        spinner="bubbles"
        @infinite="infiniteScroll"
      >
        <div slot="no-more" />
        <div slot="no-results" />
      </infinite-loading>
    </div>
    <div>
      <!-- button trigger -->
      <div class="demo-inline-spacing" />

      <!-- modal -->
      <!-- <b-modal
        id="modal-primary"
        v-model="modalIsOpen"
        ok-only
        ok-title="Отмена"
        modal-class="modal-primary"
        centered
        title="Primary Modal"
      >
        <div>Вы действительно хотите удалить сезон?</div>
        <b-button
          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
          class="mt-1"
          variant="primary"
          @click="deleteItem(seasonToDelete)"
        >
          Удалить
        </b-button>
      </b-modal> -->

    </div>
  </div>
</template>

<script>
import {
  BBadge,
  BDropdown,
  BDropdownItem,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BButton,
  VBTooltip,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import Ripple from 'vue-ripple-directive'
import InfiniteLoading from 'vue-infinite-loading'
import crud_module from '../../../libs/crud_module'

const donations_module = crud_module({
  entity_name: 'donations',
})

// why the backend thinks a donation may be an entry fee (donation.entry_fee_risk)
const ENTRY_FEE_RISK_TOOLTIPS = {
  registered_unpaid: 'У пользователя была неоплаченная регистрация на этот старт',
  abandoned_attempt: 'Пользователь недавно начинал регистрацию на этот старт',
  amount_matches: 'Сумма совпадает с ценой дистанции',
}

export default {
  components: {
    VueGoodTable,
    BBadge,
    BFormCheckbox,
    BFormGroup,
    BFormInput,
    BDropdown,
    BDropdownItem,
    BButton,
    InfiniteLoading,
  },
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
  data() {
    return {
      skipCount: 9,
      maxResultCount: 9,
      modalIsOpen: false,
      onlyEntryFeeRisk: false,
      infiniteId: 0,
      seasonToDelete: null,
      columns: [
        {
          label: 'Номер заказа',
          field: 'order_number',
        },
        {
          label: 'Сумма',
          field: 'price',
        },
        {
          label: 'Старт id',
          field: 'start_id',
        },
        {
          label: 'ID платежа ЮKassa',
          field: 'external_order_id',
        },
        {
          label: 'Дата',
          field: this.formatDate,
        },
        {
          label: 'Проверка',
          field: 'entryFee',
          sortable: false,
        },
        // {
        //   label: 'Действие',
        //   field: 'action',
        // },
      ],
      rows: [],
      pageLength: '',
      dir: false,
      searchTerm: '',
      status: [
        {
          1: 'Current',
          2: 'Professional',
          3: 'Rejected',
          4: 'Resigned',
          5: 'Applied',
        },
        {
          1: 'light-primary',
          2: 'light-success',
          3: 'light-danger',
          4: 'light-warning',
          5: 'light-info',
        },
      ],
    }
  },
  computed: {
    statusVariant() {
      const statusColor = {
        /* eslint-disable key-spacing */
        Current: 'light-primary',
        Professional: 'light-success',
        Rejected: 'light-danger',
        Resigned: 'light-warning',
        Applied: 'light-info',
        /* eslint-enable key-spacing */
      }

      return status => statusColor[status]
    },
  },
  async created() {
    await this.loadFirstPage()
  },
  methods: {
    filterParams() {
      return this.onlyEntryFeeRisk ? { entryFeeRisk: 'any' } : {}
    },
    async loadFirstPage() {
      try {
        const payload = {
          skipCount: '',
          maxResultCount: this.maxResultCount,
          ...this.filterParams(),
        }
        this.rows = await donations_module.fetchItems(payload)
          .then(res => res.data.rows)
      } catch (e) {
        console.error(e)
      }
    },
    async reload() {
      this.skipCount = this.maxResultCount
      await this.loadFirstPage()
      // restarts the infinite scroll from the new first page
      this.infiniteId += 1
    },
    hasEntryFeeRisk(row) {
      return !!row.entryFeeRisk && row.entryFeeRisk !== 'none'
    },
    entryFeeRiskTooltip(risk) {
      return ENTRY_FEE_RISK_TOOLTIPS[risk] || 'Пожертвование похоже на оплату участия в старте'
    },
    async infiniteScroll($state) {
      const payload = {
        skipCount: this.skipCount,
        maxResultCount: this.maxResultCount,
        ...this.filterParams(),
      }
      await donations_module.fetchItems(payload)
        .then(res => {
          if (res.data.rows.length > 0) {
            this.rows.push(...res.data.rows)
            this.skipCount += this.maxResultCount
            $state.loaded()
          } else {
            $state.complete()
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    async deleteItem(id) {
      const payload = {
        skipCount: '',
        maxResultCount: this.maxResultCount,
      }
      await donations_module.deleteItem(id)
      await donations_module.fetchItems(payload)
        .then(response => {
          this.rows = response.data.rows
        })
      this.modalIsOpen = false
    },
    formatDate(rowObj) {
      const newDate = new Date(rowObj.createdAt)
      const options = { year: 'numeric', month: 'long', day: 'numeric' }
      const newStr = newDate.toLocaleDateString('ru', options)
      return newStr
    },
  },
}
</script>

<style lang="scss" scoped>

</style>

<style lang="scss">
  .edit-button{
    padding: 0.65rem 1.28rem;
    display: flex;
    align-items: center;

    &:hover{
      background-color: rgba(115, 103, 240, 0.12);
    }
  }
  @import '@core/scss/vue/libs/vue-good-table.scss';
</style>
